import RMSvgIcon, {
  RMSvgIconProps,
} from 'components/customComponents/CommonComponents/RMSvgIcon';
import React from 'react';

interface Props {
  title: string;
  iconProps: RMSvgIconProps;
  backgroundColor: string;
}

const AlertBox = (props: Props) => {
  const { title, iconProps, backgroundColor } = props;
  return (
    <div
      id="alert-box-wrapper"
      className={`w-full bg-[${backgroundColor}] mx-2 border-t-[1px] border-r-[1px] border-b-[1px] border-l-[3px] border-[${iconProps.fill}] p-[8px] flex flex-row gap-[8px] items-start`}
    >
      <RMSvgIcon id="alert-box-rm-icon" {...iconProps} />
      <label
        id="alert-box-title-label"
        className="font-normal leading-[19px] text-[16px]"
      >
        {title}
      </label>
    </div>
  );
};

export default AlertBox;
